import type { ReviewErrorMessages } from '../../types';

// useFetch reports a non-2xx response as exactly "HTTP Error: <status>". Match the whole
// string: substring matching would read a JSON parse error at "position 1403" as a 403.
export const describeError = (
    error: string | null | undefined,
    messages: ReviewErrorMessages
): string => {
    const status = Object.keys(messages.byStatus).find(code => error === `HTTP Error: ${code}`);

    return status ? messages.byStatus[status] : messages.fallback;
};
